import { ReactNode } from 'react';
import { useAuth } from '../hooks';
import { Role } from '../types';

/**
 * Renders children for dealers only. Wrap the whole connected widget (not just its markup),
 * so queries inside never fire for other roles. The API still has to enforce access on its own.
 */
export const DealerOnly = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  return user?.role === Role.Dealer ? <>{children}</> : null;
};
